export const roundedNumberValueMapper = ({ value }: { value?: number }) =>
  value ? Math.floor(value) : '';

roundedNumberValueMapper.displayName = 'roundedNumberValueMapper';
